import { useCallback } from 'react'

import enhancedFetch from '../libs/enhancedFetch'

import { useAuthContext } from './AuthProvider'

export const useAuthedFetch = () => {
  const { accessToken, idToken, logout, updateTokens } = useAuthContext()

  const authedFetch = useCallback(
    async (method, url, options = {}) => {
      // Inject access token in headers
      if (!accessToken.jwtToken) {
        throw new Error('Authed fetch needs a token')
      }

      // Check if current access token is no longer valid
      let accessJwtToken = accessToken.jwtToken
      if (Date.now() >= accessToken.payload.exp * 1000) {
        try {
          const { accessToken } = await updateTokens()
          accessJwtToken = accessToken.jwtToken
        } catch (error) {
          logout()
        }
      }

      const headers = options.headers ?? {}
      headers['Authorization'] = `Bearer ${accessJwtToken}`
      headers['id_token'] = idToken.jwtToken
      headers['Access-Control-Allow-Origin'] = '*'

      try {
        return await enhancedFetch(method, url, {
          ...options,
          headers,
        })
      } catch (e) {
        throw e
      }
    },
    [accessToken, idToken, logout, updateTokens],
  )

  return authedFetch
}
